import React, { useState, useEffect, useCallback } from "react";
import { Row, Col, Form, Container, FormGroup } from "react-bootstrap";
import { connect } from "react-redux";
import { GetExpenseReport } from "./ExpenseActions";
import { setHeading } from "../../../accounts/account.actions";
import moment from "moment";
import SendIcon from "@mui/icons-material/Send";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";


const ExpenseReport = ({ GetExpenseReport, setHeading }) => {
    const defaultStartDate = moment().subtract(30, "days").format("YYYY-MM-DD");
    const defaultEndDate = moment().format("YYYY-MM-DD");
    const [startDate, setStartDate] = useState(defaultStartDate);
    const [endDate, setEndDate] = useState(defaultEndDate);
    const [error, setError] = useState("");

    useEffect(() => {
        setHeading("Expense Report");
    }, [setHeading]);

    const validateDates = useCallback(() => {
        if (!startDate || !endDate) {
            setError("Start Date and End Date are required.");
            return false;
        }

        if (moment(startDate).isAfter(endDate)) {
            setError("Start Date cannot be greater than End Date.");
            return false;
        }

        setError("");
        return true;
    }, [startDate, endDate]);

    // Common Report Handler
    const handleReport = useCallback(
        (type) => {
            if (!validateDates()) return;
            const payload = {
                startDate,
                endDate,
                type,
            };
            GetExpenseReport(payload, startDate, endDate);
        },
        [validateDates, startDate, endDate, GetExpenseReport]
    );

    return (
        <Container fluid>
            <Row>
                <Col md={6}>
                    <FormGroup>
                        <Form.Label><b>Start Date *</b></Form.Label>
                        <Form.Control
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                        />
                    </FormGroup>
                </Col>

                <Col md={6}>
                    <FormGroup>
                        <Form.Label><b>End Date *</b></Form.Label>
                        <Form.Control
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                        />
                    </FormGroup>
                </Col>
            </Row>

            {error && (
                <Stack sx={{ mt: 2 }}>
                    <Alert severity="error">{error}</Alert>
                </Stack>
            )}

            <div className="sendDiv" style={{ display: "flex", gap: "10px", marginTop: "20px", flexWrap: "wrap" }} >
                <Button
                    variant="contained"
                    endIcon={<SendIcon />}
                    size="large"
                    onClick={() => handleReport("excel")}
                >
                    DOWNLOAD EXCEL
                </Button>

                <Button
                    variant="contained"
                    endIcon={<SendIcon />}
                    size="large"
                    onClick={() => handleReport("pdf")}
                >
                    PRINT PDF
                </Button>
            </div>
        </Container>
    );
};

const mapDispatchToProps = (dispatch) => ({
    GetExpenseReport: (data, startDate, endDate) => dispatch(GetExpenseReport(data, startDate, endDate)),
    setHeading: (data) => dispatch(setHeading(data)),
});

export default connect(null, mapDispatchToProps)(ExpenseReport);